<div provideParentForm>
    <div class="full-modal-config__form-control-row">
        <div class="full-modal-config__form-control">
            <avi-fieldset [hideContent]="true">
                <avi-fieldset_header class="gslb-pool-member-domain-name__avi-fieldset-header">
                    <avi-input-container noMarginTop>
                        <label
                            aviLabelWithTooltip
                            objectType="{{ objectType }}"
                            fieldName="fqdn"
                            for="fqdn"
                            required
                        >
                            {{ ( isGSLBServiceRecordTypeSRV ?  l10nKeys.fqdnInputLabel : l10nKeys.ipOrFqdnInputLabel ) | vtranslate }}
                        </label>
                        <input
                            name="fqdn"
                            id="fqdn"
                            type="text"
                            clrInput
                            regexPattern="anyIPHostname"
                            placeholder="{{ (isGSLBServiceRecordTypeSRV ? l10nKeys.fqdnInputPlaceholder : l10nKeys.ipOrFqdnInputPlaceholder) | vtranslate }}"
                            [(ngModel)]="ipOrFqdnInputValue"
                            (ngModelChange)="handleIpOrFqdnChange()"
                            required
                        />
                    </avi-input-container>

                    <avi-checkbox
                        *ngIf="!isGSLBServiceRecordTypeSRV"
                        objectType="{{ objectType }}"
                        fieldName="resolve_fqdn_to_v6"
                        [(ngModel)]="editable.config.resolve_fqdn_to_v6"
                        name="resolve-fqdn-to-v6"
                        id="resolve-fqdn-to-v6"
                    >
                        {{ l10nKeys.resolveFqdnToV6Label | vtranslate }}
                    </avi-checkbox>
                </avi-fieldset_header>
            </avi-fieldset>
        </div>
    </div>
</div>
